import React, { useEffect, useRef } from 'react';

import { useContextStore } from '../../../../stores/storeRoot';

const CookieDeclaration: React.FC = () => {
  const { selectedUserLanguage } = useContextStore();
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const lang =
      selectedUserLanguage.slice(0, 2) ??
      (process.env.COOKIEBOT_FALLBACK_LANGUAGE || 'en');
    if (divRef.current) {
      const script = document.createElement('script');
      script.id = 'CookieDeclaration';
      script.src = `https://consent.cookiebot.com/${process.env.COOKIEBOT_ID || 'not set'}/cd.js`;
      script.setAttribute('data-culture', lang);
      script.type = 'text/javascript';
      script.async = true;

      divRef.current.appendChild(script);
    }

    // Cleanup and remove script
    return () => {
      if (divRef.current) {
        const scriptElement =
          divRef.current.querySelector('#CookieDeclaration');
        if (scriptElement) {
          divRef.current.removeChild(scriptElement);
        }
      }
    };
  }, []);

  return <div ref={divRef} />;
};

export default CookieDeclaration;
